import { Copy } from '../copy/Copy';

export const PROFILE_NAV_TABS = [
  Copy.generate('Global.summary'),
  Copy.generate('Global.activities'),
  Copy.generate('Global.achievements'),
];
